module.exports = __webpack_public_path__ + "static/mmr-6035aecb4885a2b0fdfaf37c7ff9375b.png";